import React, { useState, useEffect } from "react";

const Input = ({ type = "text", placeholder, onChange, label, font = "text-white", val }) => {
  const [inputValue, setInputValue] = useState(""); // Estado para controlar o valor do input
  
  useEffect(() => {
    // Definir o valor do input após o componente carregar
    setInputValue(val);
  }, [val]);

  const handleChange = (e) => {
    setInputValue((val ? val : e.target.value)); // Atualiza o estado local com o valor do input
    onChange && onChange(e.target.value); // Chama a função onChange passada via props, se houver
  };

  return (
    <div className="mb-4">
    <label className="font-special block mb-2 text-sm font-bold text-white">{label}
    <input
      type={type} // Tipo do input (texto, número, etc.)
      value={inputValue} // Valor controlado pelo estado local
      onChange={handleChange} // Chama a função handleChange ao digitar
      placeholder={placeholder} // Placeholder opcional
      className="text-xl bg-dour-suave border border-dour-suave text-sm rounded-full focus:ring-cinza-cl focus:border-cinza-cl-500 block w-full p-2.5 ${fontColor}" />
    </label>
    </div>
  );
};

export default Input;